import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const SubjectNotificationBarGraph = ({ siteNotification }) => {
  const [siteNotificationBarGraph, setSiteNotificationBarGraph] = useState({
    series: [
      {
        name: "No. of Notification",
        data: siteNotification || [],
      },
    ],

    options: {
      chart: {
        type: "bar",
        height: 350,
        stacked: true,
      },
      stroke: { width: 1, colors: ["#fff"] },
      plotOptions: {
        bar: { horizontal: true },
      },
      xaxis: {
        categories: ["Open", "Closed"],
        labels: {
          style: {
            colors: ["#103C5E8C", "#103C5E99"],
            fontSize: "12px",
          },
        },
      },
      fill: { opacity: 1 },
      colors: ["#103C5E8C", "#103C5E99"],
      legend: {
        position: "bottom",
        showForSingleSeries: true,
      },
    },
  });

  useEffect(() => {
    setSiteNotificationBarGraph((prevChartData) => ({
      ...prevChartData,
      series: [{ data: siteNotification || [] }],
    }));
  }, [siteNotification]);

  return (
    <div>
      <ReactApexChart
        options={siteNotificationBarGraph.options}
        series={siteNotificationBarGraph.series}
        type="bar"
        height={200}
      />
    </div>
  );
};

export default SubjectNotificationBarGraph;
